<template>
  <div class="search-box">
    <font-awesome-icon icon="search" class="icon" />
    <b-form-input v-model="input" class="input" :placeholder="placeholder" />
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'ค้นหา' }
  },
  data () {
    return {
      input: this.value,
      placeholderText: this.placeholder
    }
  },
  watch: {
    input (input) { this.$emit('input', input) }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  position: relative;

  .icon {
    background: none;
    border-right: 0;
    position: absolute;
    top: 10px;
    left: 10px;
    color: $gray-500;
  }

  .input {
    padding-left: 32px;
  }
}
</style>
